<template>
	<div id="app2" class="container-fluid serve-container">
		<div class="serve bg"></div>
		<Serve></Serve>
	</div>
</template>

<script>
   
    import Serve from '../components/Serve.vue';
	
    export default {
        name: 'app2',
		components:
            { Serve },
		mounted: function () {
		
		}
    };
</script>

<style>

    @font-face {
        font-family: "Roboto Slab";
        src: url("/fonts/RobotoSlab-VariableFont_wght.ttf");
    }


</style>

